<template>
  <el-dialog
    append-to-body
    :title="title"
    :visible.sync="dialogVisible"
    width="90%"
    :before-close="closeDialog"
    class="custom-dialog"
  >
    <el-form :model="changePwForm" ref="changePwForm" class="custom-from">
      <el-form-item label="用户名称：" prop="userName">
        <el-input
          disabled
          placeholder="请输入用户名称"
          v-model="currentUserName"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="修改密码："
        required
        :rules="[{ required: true, message: '请输入新密码', trigger: 'blur' }]"
        prop="passWord"
        class="createUserPassword"
      >
        <el-input
          placeholder="请输入新密码"
          :type="eyeFlag ? 'text' : 'password'"
          class="passwordIcon"
          v-model.trim="changePwForm.passWord"
        >
          <!-- <i
            slot="suffix"
            class="font18"
            :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
            @click="eyeFlag = !eyeFlag"
          ></i> -->
        </el-input>
      </el-form-item>

      <el-form-item
        class="createUserPassword"
        label="确认密码："
        required
        :rules="[
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: this.validateConfirm, trigger: 'blur' }
        ]"
        prop="reconfirmPassword"
      >
        <el-input
          placeholder="请确认新密码"
          :type="eyeFlag2 ? 'text' : 'password'"
          class="passwordIcon"
          v-model.trim="changePwForm.reconfirmPassword"
        >
          <!-- <i
            slot="suffix"
            class="font18"
            :class="[eyeFlag2 ? 'el-icon-view' : 'iconfont icon-biyanjing']"
            @click="eyeFlag2 = !eyeFlag2"
          ></i> -->
        </el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" @click="colseDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogVisible', 'title', 'currentUserName'],
  data () {
    return {
      getLoginUser: JSON.parse(localStorage.getItem('userInfo')).userName,
      changePwForm: { userName: '', passWord: '', reconfirmPassword: '' },
      eyeFlag: false,
      eyeFlag2: false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
      this.$refs.changePwForm.resetFields()
    },
    confirmDialog () {
      this.$refs.changePwForm.validate(async valid => {
        if (valid) {
          try {
            this.$emit('commitChangePw', this.changePwForm)
          } catch (error) {}
        } else {
          console.log('error submit!!')
          return false
        }
        this.$emit('closeDialog')
        this.$refs.changePwForm.resetFields()
      })
    },

    // 密码二次确认校验
    validateConfirm (rule, value, callback) {
      const passWord = this.changePwForm.passWord
      if (value !== passWord) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },

    colseDialog () {
      this.$emit('closeDialog')
      this.$refs.changePwForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped></style>
